import { createContext } from "react";

const TableContext = createContext({
  /** @type {import("@tanstack/react-table").Table<any>} */
  table: null,
  setData: () => {},
});

export default TableContext;
